// @ts-nocheck
import {
  PairedSalesAnalysisFeature,
  PairedSalesCustomAnalysisFeature,
  isObject,
  isString,
} from '@aloft/toolkit-shared';

export function isPairedSalesCustomAnalysisFeature(
  x: PairedSalesAnalysisFeature,
): x is PairedSalesCustomAnalysisFeature {
  return !isString(x) && isObject(x) && 't' in x && 'name' in x;
}
